import { FETCH_ALL_SCHOOLS } from "../../constants";

export default function (state = [], action) {
  switch(action.type){
    case FETCH_ALL_SCHOOLS:
      return action.schools;
    default:
      return state;
  }
}